/**
 * List of states for a tearsheet
 */
export enum TearsheetState {
    Requested = 'Requested',
    Submitted = 'Submitted',
    Approved = 'Approved',
    Published = 'Published',
}

export enum TearsheetUnit {
  USD = 'USD',
  ratio = 'ratio',
  percent = 'percent',
  irr = 'irr',
  Boepd = 'Boepd',
  Mboe = 'Mboe',
  date = 'date',
  Mmbtupd = 'Mmbtupd',
  unitless = 'unitless',
  Mcfepd = 'Mcfepd', 
  Bcfe = 'Bcfe',
  Mbbl = 'Mbbl',
  Mmcf = 'Mmcf',
  Mcfd = 'Mcf/d',
  kW = 'kW',
  Mwh = 'Mwh',
  Date = 'Date',
  shortDate = 'shortDate'
}

export enum TearsheetValue {
  COST = 'Cost'
}

export enum QuantumFunds {
  QIFI = 'QIFI',
  QIFII = 'QIFII',
  QIFIFundFamily = 'QIF I',
  QIFIIFundFamily = 'QIF II'
}

export enum MoicRoundOff {
  min = 0.99,
  max = 1.01
}

export enum ExternalPDFFileType {
  introduction = "introduction",
  highlights = "highlights",
  appendix = "appendix"
}

export enum TearsheetJobStatus {
  queued = 'queued',
  running = 'running',
  completed = 'completed',
  failed = 'failed',
  not_found = 'not_found'
}

export enum TearsheetFetchType {
  normal = "normal",              // Return tearsheet collection data
  combinePC = "combinePC",        // Base on config combineMnemonic(=mnemonic) check, fetch tearsheet data base on logoSource
  mnemonicArray = "mnemonicArray", // Base on config mnemonic[] check, fetch tearsheet data base on logoSource
  aggregated = "aggregated"
}

export enum TearsheetAggregatedFunds {
  qcsii = "QCS II"
}